{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-passport-google-oauth-ui",
  "version": "0.1.10",
  "keywords": [
    "authentication",
    "google",
    "login",
    "npm",
    "oauth",
    "package",
    "passport",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "bugs": "https://github.com/okayasu/verdaccio-passport-google-oauth-ui/issues",
  "repository": {
    "url": "git+https://github.com/okayasu/verdaccio-passport-google-oauth-ui.git"
  },
  "license": "MIT",
  "author": "Masanori Okayasu",
  "main": "dist/server/index.js",
  "bin": {
    "verdaccio-passport-google-oauth-ui": "dist/cli/index.js"
  },
  "files": [
    "dist",
    "verdaccio.yaml"
  ],
  "scripts": {
    "build": "bash run build",
    "clean": "bash run clean",
    "cli": "bash run cli",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "run-s update start",
    "docker": "bash run docker_",
    "fix": "run-s format typecheck",
    "format": "prettier --write \"**/*.{ts,js,css,scss,html,json}\"",
    "format:check": "prettier --check \"**/*.{ts,js,css,scss,html,json}\"",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest",
    "typecheck": "bash run typecheck",
    "update": "run-s prepack copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"bun dev\""
  },
  "dependencies": {
    "@verdaccio/core": "^8.0.0-next-8.31",
    "@verdaccio/url": "^13.0.0-next-8.31",
    "copy-to-clipboard": "^3.3.3",
    "dotenv": "^17.3.1",
    "express": "^5.1.0",
    "global-agent": "^3.0.0",
    "lodash": "^4.17.23",
    "minimist": "^1.2.8",
    "open": "^11.0.0",
    "ow": "^3.1.1",
    "passport": "^0.7.0",
    "passport-google-oauth": "^2.0.0",
    "picocolors": "^1.1.1"
  },
  "devDependencies": {
    "@parcel/config-default": "^2.16.4",
    "@parcel/transformer-typescript-tsc": "^2.16.4",
    "@types/express": "^5.0.3",
    "@types/global-agent": "^3.0.0",
    "@types/lodash": "^4.17.24",
    "@types/minimist": "^1.2.5",
    "@types/node": "^24.12.0",
    "@types/passport": "^1.0.17",
    "@types/passport-google-oauth": "^1.0.45",
    "@verdaccio/types": "^13.0.0-next-8.11",
    "@vitest/coverage-v8": "^4.0.18",
    "browserslist": "^4.28.1",
    "core-js": "^3.48.0",
    "nodemon": "^3.1.14",
    "npm-run-all2": "^8.0.4",
    "parcel": "^2.16.4",
    "prettier": "^3.8.1",
    "process": "^0.11.10",
    "timekeeper": "^2.3.1",
    "type-fest": "^5.4.4",
    "typescript": "^5.9.3",
    "verdaccio": "^6.3.1",
    "verdaccio-htpasswd": "^13.0.0-next-8.31",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.0.18"
  },
  "peerDependencies": {
    "verdaccio": ">=6"
  },
  "engines": {
    "node": ">=20"
  },
  "publishConfig": {
    "registry": "https://registry.npmjs.org/"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-6.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  }
}
